import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { HojasCallCenterComponent } from '../hojas-call-center.component';
import { Cliente } from '../models/Cliente';
import { firstValueFrom } from 'rxjs';
import { GlassTalleresService } from '../services/glass-talleres.service';
import { ClienteService } from '../services/bd/Cliente/cliente.service';
import { getErrorMessage } from '../helpers/error';
import { BusquedaSiniestrosGtComponent } from './busqueda-siniestros.component';
import { BusquedaTalleresGtComponent } from './busqueda-talleres.component';

const REGEX_CODPOS = /^\d{1,5}$/;
const REGEX_NOMBRE = /^[a-zA-ZÁÉÍÓÚÜÑáéíóúüñ][a-zA-ZÁÉÍÓÚÜÑáéíóúüñ\s.'\-]{0,29}$/;
const REGEX_TELEFONO = /^\+?[1-9]\d{1,14}$/;
const REGEX_MATRICULA = /^(?:[0-9]{4}[A-Z]{3})|(?:[A-Z]{1}[0-9]{4}[A-Z]{2})|(?:[A-Z]{2}-[0-9]{4}-[A-Z]{1})|(?:[A-Z]{2}-[0-9]{5})|(?:E [0-9]{4} [A-Z]{3})|(?:[A-Z]{4}[0-9]{4}[A-Z]{1})|(?:[A-Z]{3}[0-9]{4}[A-Z]{1})|(?:[A-Z]{2}[0-9]{6})|(?:C[0-9]{4}[B-Z]{3})|(?:E[.·][0-9]{4})|(?:[E-Z][A-Z][0-9]{4}[A-Z]{1})|(?:[CGPC][0-9]{4}[A-Z]{1})$/i;

@Component({
  selector: 'ral-glass-talleres',
  templateUrl: './glass-talleres.component.html',
  styleUrls: ['./glass-talleres.component.scss']
})
export class GlassTalleresComponent extends VentanaFlotante implements AfterViewInit {
  @ViewChild('siniestroPanel') private siniestroPanel?: ElementRef<HTMLElement>;

  private formularioHojas: HojasCallCenterComponent;
  protected guardando = false;
  protected buscando = false;
  protected buscandoIncidencia = false;
  protected buscandoTalleres = false;
  protected cargandoCias = false;
  protected selectedTabIndex = 0;
  protected incidenciaPanelHeight: number | null = null;
  private cias: Cliente[] = [];
  protected ciasFiltradas$: Observable<Cliente[]> = of([]);
  protected canalEntradaList = [
    { value: 'TRANSFERENCIA LLAMADA', label: 'Transferencia de llamada' },
    { value: 'SIN LLAMADA', label: 'Envío sin llamada' },
  ];
  protected incidenciaList = [
    'Cambio de cita',
    'Cancelación de servicio',
    'Estado del servicio',
    'Autorización del siniestro',
    'Otros',
  ];
  protected danosList = [
    { value: 'FRONT REPAIR', label: 'REPARACIÓN DE PARABRISAS' },
    { value: 'FRONT REPLACE', label: 'SUSTITUCIÓN DE PARABRISAS' },
    { value: 'BACKCENTER REPLACE', label: 'SUSTITUCIÓN LUNETA TRASERA' },
    { value: 'BACKLEFT REPLACE', label: 'SUSTITUCIÓN LUNETA TRASERA IZQUIERDA' },
    { value: 'BACKRIGHT REPLACE', label: 'SUSTITUCIÓN LUNETA TRASERA DERECHA' },
    { value: 'FRONTQUARTERLEFT REPLACE', label: 'SUSTITUCIÓN LUNA CUSTODIA DELANTERA IZQUIERDA' },
    { value: 'FRONTQUARTERRIGHT REPLACE', label: 'SUSTITUCIÓN LUNA CUSTODIA DELANTERA DERECHA' },
    { value: 'FRONTLEFT REPLACE', label: 'SUSTITUCIÓN DESCENDENTE DELANTERO IZQUIERDO' },
    { value: 'FRONTRIGHT REPLACE', label: 'SUSTITUCIÓN DESCENDENTE DELANTERO DERECHO' },
    { value: 'FRONTVENTLEFT REPLACE', label: 'SUSTITUCIÓN FIJO DELANTERO IZQUIERDO' },
    { value: 'FRONTVENTRIGHT REPLACE', label: 'SUSTITUCIÓN FIJO DELANTERO DERECHO' },
    { value: 'MIDDLELEFT REPLACE', label: 'SUSTITUCIÓN LATERAL CENTRAL IZQUIERDO' },
    { value: 'MIDDLERIGHT REPLACE', label: 'SUSTITUCIÓN LATERAL CENTRAL DERECHO' },
    { value: 'MIDDLEQUARTERLEFT REPLACE', label: 'SUSTITUCIÓN LUNA CUSTODIA CENTRAL IZQUIERDA' },
    { value: 'MIDDLEQUARTERRIGHT REPLACE', label: 'SUSTITUCIÓN LUNA CUSTODIA CENTRAL DERECHA' },
    { value: 'REARQUARTERLEFT REPLACE', label: 'SUSTITUCIÓN COSTADO TRASERO IZQUIERDO' },
    { value: 'REARQUARTERRIGHT REPLACE', label: 'SUSTITUCIÓN COSTADO TRASERO DERECHO' },
    { value: 'REARLEFT REPLACE', label: 'SUSTITUCIÓN DESCENDENTE TRASERO IZQUIERDO' },
    { value: 'REARRIGHT REPLACE', label: 'SUSTITUCIÓN DESCENDENTE TRASERO DERECHO' },
    { value: 'REARVENTLEFT REPLACE', label: 'SUSTITUCIÓN FIJO TRASERO IZQUIERDO' },
    { value: 'REARVENTRIGHT REPLACE', label: 'SUSTITUCIÓN FIJO TRASERO DERECHO' },
    { value: 'ROOF REPLACE', label: 'SUSTITUCIÓN TECHO PANORÁMICO' },
    { value: 'UNKNOWN REPLACE', label: 'OTRO' },
  ];
  protected glassForm = this.formBuilder.group({
    telefono: ['', [Validators.required, Validators.maxLength(15), Validators.pattern(REGEX_TELEFONO)]],
    matricula: ['', [Validators.required, Validators.maxLength(20), Validators.pattern(REGEX_MATRICULA)]],
    compania: ['' as string | Cliente, [Validators.required]],
    codigoPostal: ['', [Validators.required, Validators.pattern(REGEX_CODPOS)]],
    danos: [[] as string[], [Validators.required]],
    canalEntrada: ['', [Validators.required, Validators.maxLength(50)]],
    gtTaller: ['', [Validators.maxLength(100)]],
    nombre: ['', [Validators.required, Validators.maxLength(30), Validators.pattern(REGEX_NOMBRE)]],
  });
  protected incidenciaForm = this.formBuilder.group({
    matricula: ['', [Validators.required, Validators.maxLength(20), Validators.pattern(REGEX_MATRICULA)]],
    otralarsa: [''],
    incidencia: ['', [Validators.required]],
    incidenciaOtros: ['', [Validators.maxLength(230)]],
  });
  /** id_ralarsa del siniestro elegido en el tab Incidencia */
  private idRalarsaSeleccionado: string = '';
  /** Resumen del siniestro seleccionado (Incidencia) */
  protected resumenSiniestroIncidencia: {
    nombre: string;
    estado: string;
    fecha_cita: string;
  } | null = null;

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: {formularioHojas: HojasCallCenterComponent},
    private formBuilder: FormBuilder,
    private glassTalleresService: GlassTalleresService,
    private clienteService: ClienteService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  )
  {
    super(dialogRef, data);
    this.formularioHojas = data.formularioHojas;
    if (this.formularioHojas.extranjera) {
      this.glassForm.get('matricula')?.setValidators([Validators.required, Validators.maxLength(20)]);
      this.glassForm.get('matricula')?.updateValueAndValidity({ emitEvent: false });
      this.incidenciaForm.get('matricula')?.setValidators([Validators.required, Validators.maxLength(20)]);
      this.incidenciaForm.get('matricula')?.updateValueAndValidity({ emitEvent: false });
    }
    this.initCiasAutocomplete();
    this.prefillFromHojas();
    this.cargarCias();
  }

  ngAfterViewInit(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => this.syncIncidenciaHeight(), 0);
      setTimeout(() => this.syncIncidenciaHeight(), 100);
    });
  }

  displayCia = (option: Cliente | string | null): string => {
    if (!option) {
      return '';
    }
    if (typeof option === 'string') {
      return option.trim();
    }
    return `${(option.nombre || '').trim()} ${(option.cliente || '').trim()}`.trim();
  };

  campoInvalido(nombre: string): boolean {
    const control = this.glassForm.get(nombre);
    if (!control) {
      return false;
    }
    const value = (control.value ?? '').toString().trim();
    if (!value) {
      return false;
    }
    return control.hasError('pattern') && (control.dirty || control.touched);
  }

  onCompaniaFocus(): void {
    const ctrl = this.glassForm.get('compania');
    ctrl?.setValue(ctrl.value || '', { emitEvent: true });
  }

  private initCiasAutocomplete(): void {
    this.ciasFiltradas$ = this.glassForm.get('compania')!.valueChanges.pipe(
      startWith(this.glassForm.get('compania')?.value || ''),
      map(value => this.filterCias(value))
    );
  }

  private filterCias(value: string | Cliente | null): Cliente[] {
    const filterValue = (typeof value === 'string'
      ? value
      : this.displayCia(value)
    ).toLowerCase().trim();

    if (!filterValue) {
      return this.cias;
    }
    return this.cias.filter(cia =>
      (cia.nombre || '').toLowerCase().includes(filterValue) ||
      (cia.cliente || '').toLowerCase().includes(filterValue)
    );
  }

  private async cargarCias(): Promise<void> {
    try {
      this.cargandoCias = true;
      this.cias = await this.clienteService.buscarClientes(this.formularioHojas.token) || [];
      this.glassForm.get('compania')?.updateValueAndValidity({ emitEvent: true });
    } catch (e) {
      this.cias = [];
      this.formularioHojas.mostrarArgumentario(
        'Error al cargar compañías',
        ['No se han podido cargar las compañías:', getErrorMessage(e)],
        false, true, true
      );
    } finally {
      this.cargandoCias = false;
    }
  }

  private resolveCompaniaNombre(value: string | Cliente | null | undefined): string {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value.trim().slice(0, 100);
    }
    const nombre = (value.nombre || '').trim();
    const codigo = (value.cliente || '').trim();
    return `${nombre} ${codigo}`.trim().slice(0, 100);
  }

  toUpperCaseMat(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = (input.value || '').toUpperCase();
    input.value = value;
    this.glassForm.get('matricula')?.setValue(value, { emitEvent: false });
    // Sincroniza matrícula a tab Incidencia sin declarar OT Ralarsa
    this.sincronizarMatriculaIncidencia(value, false);
  }

  toUpperCaseMatIncidencia(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = (input.value || '').toUpperCase();
    input.value = value;
    this.incidenciaForm.get('matricula')?.setValue(value, { emitEvent: false });
  }

  campoInvalidoIncidencia(nombre: string): boolean {
    const control = this.incidenciaForm.get(nombre);
    if (!control) {
      return false;
    }
    const value = (control.value ?? '').toString().trim();
    if (!value) {
      return false;
    }
    return control.hasError('pattern') && (control.dirty || control.touched);
  }

  soloNumerosCp(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = (input.value || '').replace(/\D/g, '').slice(0, 5);
    input.value = value;
    this.glassForm.get('codigoPostal')?.setValue(value, { emitEvent: false });
  }

  private syncIncidenciaHeight(): void {
    if (this.selectedTabIndex !== 0) {
      return;
    }
    const el = this.siniestroPanel?.nativeElement;
    if (!el) {
      return;
    }
    const height = Math.ceil(el.getBoundingClientRect().height);
    if (height > 0 && this.incidenciaPanelHeight !== height) {
      this.incidenciaPanelHeight = height;
      this.cdr.detectChanges();
    }
  }

  private prefillFromHojas(): void {
    const hojas = this.formularioHojas;
    const danosPrefill = this.normalizarDanosSeleccionados(hojas.danosPrismaCodigos);
    const ciaPrefill = hojas.ciaSeleccionada && typeof hojas.ciaSeleccionada !== 'string'
      ? hojas.ciaSeleccionada
      : this.getCiaDisplay();
    const matriculaPrefill = (hojas.matriculaFormControl?.value || hojas.vehiculo?.matricula || '')
      .toString().toUpperCase().trim();
    this.glassForm.patchValue({
      telefono: (hojas.telefono1FormControl?.value || hojas.asegurado?.tel1 || '').toString().trim(),
      matricula: matriculaPrefill,
      compania: ciaPrefill,
      nombre: (hojas.asegurado?.nombre || '').toString().trim(),
      danos: danosPrefill,
    });
    this.incidenciaForm.patchValue({
      matricula: matriculaPrefill,
    });
  }

  private normalizarDanosSeleccionados(codigos: string[] | string | null | undefined): string[] {
    const lista = Array.isArray(codigos)
      ? codigos
      : (codigos || '').toString().split(';');
    const resueltos: string[] = [];
    for (const item of lista) {
      const texto = (item || '').toString().trim();
      if (!texto) {
        continue;
      }
      const porValor = this.danosList.find(d => d.value.toUpperCase() === texto.toUpperCase());
      if (porValor) {
        resueltos.push(porValor.value);
        continue;
      }
      const porLabel = this.danosList.find(d => d.label.toUpperCase() === texto.toUpperCase());
      if (porLabel) {
        resueltos.push(porLabel.value);
      }
    }
    return resueltos;
  }

  async buscarTalleresPorCp(): Promise<void> {
    const codigoPostal = (this.glassForm.get('codigoPostal')?.value || '').toString().replace(/\D/g, '').slice(0, 5);
    if (!codigoPostal) {
      this.formularioHojas.mostrarArgumentario(
        'Atención',
        ['Debe indicar un código postal para buscar talleres cercanos.'],
        false, true, true
      );
      return;
    }
    this.glassForm.get('codigoPostal')?.setValue(codigoPostal, { emitEvent: false });

    try {
      this.buscandoTalleres = true;
      const coords = await firstValueFrom(this.glassTalleresService.getGeocodeResults(codigoPostal));
      if (!coords || (coords.latitude === 0 && coords.longitude === 0)) {
        this.formularioHojas.mostrarArgumentario(
          'Atención',
          ['No se ha podido localizar el código postal indicado.'],
          false, true, true
        );
        return;
      }

      const res = await this.glassTalleresService.buscarTalleresCercanos(
        this.formularioHojas.token,
        coords.latitude,
        coords.longitude
      );
      const listadoRaw = Array.isArray(res)
        ? res
        : (res?.data || res?.Data || []);
      const listado = (Array.isArray(listadoRaw) ? listadoRaw : []).map((item: any) => ({
        id: item.id ?? item.Id ?? 0,
        nombreTaller: (item.nombre_taller ?? item.nombreTaller ?? item.NombreTaller ?? '').toString().trim(),
        codigoPostal: (item.codigo_postal ?? item.codigoPostal ?? item.CodigoPostal ?? '').toString().trim(),
        poblacion: (item.poblacion ?? item.Poblacion ?? '').toString().trim(),
        provincia: (item.provincia ?? item.Provincia ?? '').toString().trim(),
        direccion: (item.direccion ?? item.Direccion ?? '').toString().trim(),
        latitud: Number(item.latitud ?? item.Latitud ?? 0),
        longitud: Number(item.longitud ?? item.Longitud ?? 0),
      }));

      if (listado.length === 0) {
        this.formularioHojas.mostrarArgumentario(
          'Sin resultados',
          ['No se han encontrado talleres cercanos para el código postal ' + codigoPostal + '.'],
          false, true, true
        );
        return;
      }

      this.dialog.open(BusquedaTalleresGtComponent, {
        data: { listado },
        maxWidth: '96vw',
        width: '1200px',
      }).afterClosed().subscribe(result => {
        if (result?.id != null && result.id !== '') {
          const id = String(result.id).trim();
          const nombre = (result.nombreTaller || '').toString().trim();
          this.glassForm.patchValue({
            gtTaller: nombre ? `${id} ${nombre}` : id,
          });
        }
      });
    } catch (e) {
      this.formularioHojas.mostrarArgumentario(
        'Error en búsqueda',
        ['El servidor ha devuelto el siguiente error:', getErrorMessage(e)],
        false, true, true
      );
    } finally {
      this.buscandoTalleres = false;
    }
  }

  async buscarSiniestro(): Promise<void> {
    const matricula = (this.glassForm.get('matricula')?.value || '').toString().toUpperCase().trim();
    if (!matricula) {
      return;
    }
    this.glassForm.get('matricula')?.setValue(matricula, { emitEvent: false });

    try {
      this.buscando = true;
      const listadoNormalizado = await this.obtenerListadoSiniestros(matricula);
      if (!listadoNormalizado) {
        return;
      }

      this.dialog.open(BusquedaSiniestrosGtComponent, {
        data: {
          listado: listadoNormalizado,
          token: this.formularioHojas.token,
          modoSeleccion: false,
        },
        maxWidth: '96vw',
        width: '1400px',
      }).afterClosed().subscribe(result => {
        if (result) {
          this.rellenarDeSiniestro(result);
          // Click en fila: declara matrícula + OT Ralarsa en tab Incidencia
          this.aplicarSiniestroIncidencia(result);
        }
      });
    } catch (e: any) {
      if (e?.status === 404) {
        return;
      }
      this.formularioHojas.mostrarArgumentario(
        'Error en búsqueda',
        ['El servidor ha devuelto el siguiente error:', getErrorMessage(e)],
        false, true, true
      );
    } finally {
      this.buscando = false;
    }
  }

  async buscarSiniestroParaIncidencia(): Promise<void> {
    const matricula = (this.incidenciaForm.get('matricula')?.value || '').toString().toUpperCase().trim();
    if (!matricula) {
      return;
    }
    this.incidenciaForm.get('matricula')?.setValue(matricula, { emitEvent: false });

    try {
      this.buscandoIncidencia = true;
      const listadoNormalizado = await this.obtenerListadoSiniestros(matricula);
      if (!listadoNormalizado) {
        return;
      }

      this.dialog.open(BusquedaSiniestrosGtComponent, {
        data: {
          listado: listadoNormalizado,
          token: this.formularioHojas.token,
          modoSeleccion: true,
        },
        maxWidth: '96vw',
        width: '1400px',
      }).afterClosed().subscribe(result => {
        if (result) {
          this.aplicarSiniestroIncidencia(result);
        }
      });
    } catch (e: any) {
      if (e?.status === 404) {
        return;
      }
      this.formularioHojas.mostrarArgumentario(
        'Error en búsqueda',
        ['El servidor ha devuelto el siguiente error:', getErrorMessage(e)],
        false, true, true
      );
    } finally {
      this.buscandoIncidencia = false;
    }
  }

  private textoOVacio(valor: any, fallback: string): string {
    const texto = (valor ?? '').toString().trim();
    return texto || fallback;
  }

  /** null = sin resultados / fallo de negocio; lanza en error HTTP distinto de 404 */
  private async obtenerListadoSiniestros(matricula: string): Promise<any[] | null> {
    const res = await this.glassTalleresService.buscarSiniestros(this.formularioHojas.token, matricula);
    const success = res?.success ?? res?.Success;
    const listado = Array.isArray(res)
      ? res
      : (res?.data || res?.Data || []);

    if (success === false || !Array.isArray(listado) || listado.length === 0) {
      return null;
    }

    return listado.map((item: any) => ({
      id_ralarsa: item.id_ralarsa ?? item.Id_ralarsa ?? item.otralarsa ?? item.Otralarsa ?? '',
      otralarsa: item.otralarsa ?? item.Otralarsa ?? item.id_ralarsa ?? item.Id_ralarsa ?? '',
      telefono: item.telefono ?? item.Telefono ?? '',
      nombre: item.nombre ?? item.Nombre ?? '',
      matricula: item.matricula ?? item.Matricula ?? '',
      compania: item.compania ?? item.Compania ?? '',
      estado: item.estado ?? item.Estado ?? '',
      fecha_cita: this.textoOVacio(
        item.fecha_cita ?? item.FechaCita ?? item.fechaCita,
        'SIN CITA INFORMADA',
      ),
      codpos: item.codpos ?? item.Codpos ?? '',
      danos: item.danos ?? item.Danos ?? '',
      expediente: this.textoOVacio(
        item.expediente ?? item.Expediente,
        'SIN EXPEDIENTE INFORMADA',
      ),
      canal_entrada: item.canal_entrada ?? item.canalEntrada ?? item.CanalEntrada ?? '',
      gt_taller: item.gt_taller ?? item.gtTaller ?? item.GtTaller ?? '',
    }));
  }

  private rellenarDeSiniestro(siniestro: any): void {
    const canal = (siniestro.canal_entrada || '').toString().trim();
    const canalValido = this.canalEntradaList.some(opt => opt.value === canal)
      ? canal
      : '';
    this.glassForm.patchValue({
      telefono: (siniestro.telefono || '').toString().trim(),
      matricula: (siniestro.matricula || '').toString().toUpperCase().trim(),
      compania: (siniestro.compania || '').toString().trim(),
      codigoPostal: (siniestro.codpos || '').toString().replace(/\D/g, '').slice(0, 5),
      danos: this.normalizarDanosSeleccionados(siniestro.danos),
      canalEntrada: canalValido,
      gtTaller: (siniestro.gt_taller || '').toString().trim(),
      nombre: (siniestro.nombre || this.glassForm.get('nombre')?.value || '').toString().trim(),
    });
    this.onDanosChange();
  }

  private aplicarSiniestroIncidencia(siniestro: any): void {
    const otralarsa = (siniestro.otralarsa ?? siniestro.id_ralarsa ?? '').toString().trim();
    const matricula = (siniestro.matricula || this.incidenciaForm.get('matricula')?.value || '')
      .toString().toUpperCase().trim();
    this.sincronizarMatriculaIncidencia(matricula, true, otralarsa, siniestro);
  }

  /**
   * Sincroniza matrícula (y opcionalmente OT Ralarsa) hacia el tab Incidencia.
   * @param declararOt si false, limpia otralarsa (solo se escribió matrícula en tab Siniestro)
   */
  private sincronizarMatriculaIncidencia(
    matricula: string,
    declararOt: boolean,
    otralarsa: string = '',
    siniestro: any = null,
  ): void {
    if (declararOt) {
      const ot = (otralarsa || '').toString().trim();
      this.idRalarsaSeleccionado = ot;
      this.resumenSiniestroIncidencia = {
        nombre: (siniestro?.nombre || '').toString().trim() || '—',
        estado: (siniestro?.estado || '').toString().trim() || '—',
        fecha_cita: this.textoOVacio(
          siniestro?.fecha_cita,
          'SIN CITA INFORMADA',
        ),
      };
      this.incidenciaForm.patchValue({
        matricula: (matricula || '').toString().toUpperCase().trim(),
        otralarsa: ot,
      }, { emitEvent: false });
      setTimeout(() => this.syncIncidenciaHeight(), 0);
      return;
    }

    this.idRalarsaSeleccionado = '';
    this.resumenSiniestroIncidencia = null;
    this.incidenciaForm.patchValue({
      matricula: (matricula || '').toString().toUpperCase().trim(),
      otralarsa: '',
    }, { emitEvent: false });
    setTimeout(() => this.syncIncidenciaHeight(), 0);
  }

  onGuardarClick(): void {
    if (this.selectedTabIndex === 1) {
      this.guardarIncidencia();
      return;
    }
    this.guardar();
  }

  async guardarIncidencia(): Promise<void> {
    this.incidenciaForm.markAllAsTouched();
    const otralarsa = (
      this.incidenciaForm.get('otralarsa')?.value ||
      this.idRalarsaSeleccionado ||
      ''
    ).toString().trim();
    const incidencia = this.getIncidenciaValor();

    if (!otralarsa) {
      this.formularioHojas.mostrarArgumentario(
        'Atención',
        ['Debe buscar y seleccionar un siniestro antes de guardar la incidencia.'],
        false, true, true
      );
      return;
    }
    if (!incidencia || (this.esIncidenciaOtros() && !(this.incidenciaForm.get('incidenciaOtros')?.value || '').toString().trim())) {
      this.formularioHojas.mostrarArgumentario(
        'Atención',
        ['Debe indicar el tipo de incidencia' + (this.esIncidenciaOtros() ? ' y el detalle' : '') + '.'],
        false, true, true
      );
      return;
    }

    try {
      this.guardando = true;
      await this.glassTalleresService.crearIncidencia(this.formularioHojas.token, {
        otralarsa,
        incidencia,
      });
      this.dialogRef.close(true);
      this.formularioHojas.mostrarArgumentarioRes(
        'Guardado',
        ['Incidencia enviada a Glass Talleres correctamente.'],
      ).subscribe(() => {
        location.reload();
      });
    } catch (e) {
      this.formularioHojas.mostrarArgumentario(
        'Error al guardar',
        ['Se ha producido error al enviar la incidencia a Glass Talleres:', getErrorMessage(e)],
        false, true, true
      );
    } finally {
      this.guardando = false;
    }
  }

  private getDanosConcatenados(): string {
    return this.getDanosLabels().join(';');
  }

  protected getDanosLabels(): string[] {
    const danos = this.glassForm.get('danos')?.value;
    if (!Array.isArray(danos) || danos.length === 0) {
      return [];
    }
    return danos
      .map((codigo: string) => this.danosList.find(d => d.value === codigo)?.label || codigo)
      .filter(Boolean);
  }

  onDanosChange(): void {
    setTimeout(() => this.syncIncidenciaHeight(), 0);
  }

  esIncidenciaOtros(): boolean {
    return (this.incidenciaForm.get('incidencia')?.value || '').toString().trim() === 'Otros';
  }

  onIncidenciaChange(): void {
    if (!this.esIncidenciaOtros()) {
      this.incidenciaForm.get('incidenciaOtros')?.setValue('', { emitEvent: false });
    }
    setTimeout(() => this.syncIncidenciaHeight(), 0);
  }

  /** Valor de incidencia */
  protected getIncidenciaValor(): string {
    const incidencia = (this.incidenciaForm.get('incidencia')?.value || '').toString().trim();
    if (!incidencia) {
      return '';
    }
    if (incidencia === 'Otros') {
      const detalle = (this.incidenciaForm.get('incidenciaOtros')?.value || '').toString().trim();
      return detalle ? `Otros: ${detalle}` : 'Otros:';
    }
    return incidencia;
  }

  async guardar(): Promise<void> {
    this.glassForm.markAllAsTouched();
    if (!this.glassForm.valid) {
      this.formularioHojas.mostrarArgumentario(
        'Atención',
        ['No se puede guardar hasta que se rellenen los campos obligatorios correctamente:', ...this.mensajesValidacion()],
        false, true, true
      );
      return;
    }

    const form = this.glassForm.value;
    const arrParams = {
      telefono: (form.telefono || '').toString().trim(),
      matricula: (form.matricula || '').toString().toUpperCase().trim(),
      compania: this.resolveCompaniaNombre(form.compania),
      codpos: (form.codigoPostal || '').toString().replace(/\D/g, '').slice(0, 5),
      danos: this.getDanosConcatenados(),
      canal_entrada: (form.canalEntrada || '').toString().trim(),
      gt_taller: (form.gtTaller || '').toString().trim(),
      nombre: (form.nombre || '').toString().trim(),
    };

    try {
      this.guardando = true;
      await this.glassTalleresService.crearSiniestro(this.formularioHojas.token, arrParams);
      await this.formularioHojas.guardarLlamadaEntrante(true); // llamada_gt
      this.dialogRef.close(true);
      this.formularioHojas.mostrarArgumentarioRes(
        'Guardado',
        ['Siniestro enviado a Glass Talleres correctamente.'],
      ).subscribe(() => {
        location.reload();
      });
    } catch (e) {
      this.formularioHojas.mostrarArgumentario(
        'Error al guardar',
        ['Se ha producido error al enviar el siniestro a Glass Talleres:', getErrorMessage(e)],
        false, true, true
      );
    } finally {
      this.guardando = false;
    }
  }

  private mensajesValidacion(): string[] {
    const mensajes: string[] = [];
    const controls = this.glassForm.controls;

    if (controls.telefono.invalid) {
      mensajes.push('- Teléfono debe ser un número de teléfono válido');
    }
    if (controls.matricula.invalid) {
      mensajes.push('- Matrícula debe ser una matrícula válida');
    }
    if (controls.compania.invalid) {
      mensajes.push('- Compañía debe ser una compañía válida');
    }
    if (controls.codigoPostal.invalid) {
      mensajes.push('- Código postal debe contener entre 1 y 5 dígitos');
    }
    if (controls.danos.invalid) {
      mensajes.push('- Debe seleccionar al menos un daño');
    }
    if (controls.canalEntrada.invalid) {
      mensajes.push('- Canal entrada debe ser un canal de entrada válido');
    }
    if (controls.gtTaller.invalid) {
      mensajes.push('- GT taller debe contener entre 1 y 100 caracteres');
    }
    if (controls.nombre.invalid) {
      mensajes.push('- Nombre debe contener entre 1 y 30 caracteres');
    }

    return mensajes;
  }

  private getCiaDisplay(): string {
    const cia = this.formularioHojas.ciaSeleccionada as Cliente | string | null;
    if (!cia) {
      const controlValue = this.formularioHojas.ciasDisponiblesControl?.value;
      return typeof controlValue === 'string' ? controlValue.trim() : '';
    }
    if (typeof cia === 'string') {
      return cia.trim();
    }
    return (cia.nombre || '').trim();
  }
}
